<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Advertisements" parent-page-url="/advertisements" />
      <add-edit-form
        v-if="model"
        returnUrl="/advertisements"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import Advertisement from '@/models/Advertisement'
/* eslint-disable no-undef */
export default {
  name: 'AddAdvertisement',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Advertisement' : 'Add Advertisement'
    }
  },
  data () {
    return {
      API_BASE_URL: 'advertisement',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'PSD Format', key: 'PSD', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'JPG Format', key: 'JPG', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' }
      ]
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new Advertisement()
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new Advertisement(result.advertisement)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Advertisements/AddEdit.vue